<div class="xl:flex" *ngIf="ticket">
    <div class="relative xl:flex-1">
        <rwidget-ticket-animation
            [attr.aria-hidden]="!(isTicketDisplayedAsActive && (showAnimation$ | async))"
            [style.opacity]="isTicketDisplayedAsActive && (showAnimation$ | async) ? 1 : 0"
            [style.pointer-events]="isTicketDisplayedAsActive && (showAnimation$ | async) ? 'auto' : 'none'">
        </rwidget-ticket-animation>

        <section class="flex-center relative flex flex-col justify-center gap-4 py-4 md:justify-start">
            <div
                *ngIf="isTicketDisplayedAsActive"
                [ngClass]="{
                    'bg-green flex flex-col items-center gap-6 rounded-lg border border-solid border-black/10 p-4 dark:border-contrast-yellow dark:bg-contrast-yellow':
                        isTicketDisplayedAsActive,
                    'shadow-cardStack shadowActiveBooklet': isMultiTrip(ticket)
                }">
                <rwidget-ticket-qr *ngIf="showQrCode" [ticket]="ticket" (qrClick)="qrClick()"></rwidget-ticket-qr>

                <div class="w-full" *ngIf="showTicketDetailsProgressBar && (ticketTimer$ | async) as timer">
                    <div
                        class="mb-1 text-center text-15xl font-normal text-black"
                        *ngIf="showTicketDetailsProgressTimeText && !isTicketDetailsProgressTimeTextOnRight"
                        [attr.aria-label]="('EXPIRES_IN' | translate) + ': ' + timer.remainingTimeText">
                        {{ 'EXPIRES_IN' | translate }} <span class="font-bold">{{ timer.remainingTimeText }}</span>
                    </div>

                    <div class="flex items-center gap-2">
                        <div
                            class="h-1.5 w-full overflow-hidden rounded-full bg-gray-300 dark:border dark:border-solid dark:border-contrast-black dark:bg-contrast-yellow">
                            <div
                                class="h-full rounded-full bg-secondary dark:bg-contrast-black"
                                [style.width.%]="timer.progressValue"></div>
                        </div>

                        <div
                            class="whitespace-nowrap text-15xl font-normal text-black"
                            *ngIf="showTicketDetailsProgressTimeText && isTicketDetailsProgressTimeTextOnRight"
                            [attr.aria-label]="('EXPIRES_IN' | translate) + ': ' + timer.remainingTimeText">
                            {{ 'EXPIRES_IN' | translate }} <span class="font-bold">{{ timer.remainingTimeText }}</span>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <p class="text-lg font-semibold text-black">{{ 'ACTIVE_TICKET' | translate }}</p>
                    <p class="text-base text-black">
                        {{ ticket.startDate | formatTimeZone: dateTimeFormat : timezone }}<br />
                        {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                    </p>
                </div>

                <div
                    class="flex h-6 w-fit items-center justify-center rounded-full bg-secondary px-2 text-sm dark:bg-contrast-yellow"
                    *ngIf="ticket.allowedActions?.activationsLeft && isMultiTrip(ticket)">
                    <p class="orb-app-light-dark:text-white font-bold text-black">
                        {{ ticket.allowedActions?.activationsLeft }} {{ 'BOOKLET_ACTIVATIONS_LEFT' | translate }}
                    </p>
                </div>
            </div>

            <div
                class="w-9/12 rounded-lg border border-solid border-black/10 bg-grey-white_smoke p-4 text-center dark:bg-contrast-yellow dark:text-contrast-black"
                *ngIf="
                    ticket.status === FareContractStatus.CONFIRMED ||
                    ticket.status === FareContractStatus.CANCELLED ||
                    ticket.status === FareContractStatus.PENDING ||
                    ticket.status === FareContractStatus.EXPIRED ||
                    ticket.status === FareContractStatus.REFUNDED ||
                    ticket.status === FareContractStatus.CONSUMED ||
                    ticket.status === FareContractStatus.AWAITING_REACTIVATION ||
                    isTicketNotCurrentlyValid
                "
                [ngClass]="{
                    'bg-red-secondary': ticket.status === FareContractStatus.CANCELLED,
                    'shadow-cardStack': isMultiTrip(ticket),
                    'shadowCancelledBooklet': isMultiTrip(ticket) && ticket.status === FareContractStatus.CANCELLED,
                    'shadowInactiveBooklet': isMultiTrip(ticket) && ticket.status !== FareContractStatus.CANCELLED
                }">
                <p class="text-base" *ngIf="ticket.status === FareContractStatus.PENDING && ticket.startDate">
                    <span class="font-bold">
                        {{ 'TICKET_WILL_BE_ACTIVATED_ON' | translate }}
                    </span>
                    <br />
                    {{ ticket.startDate | formatTimeZone: dateTimeFormat : timezone }}
                </p>
                <div class="flex flex-col items-center gap-6" *ngIf="isTicketNotCurrentlyValid">
                    <div class="text-center">
                        <p class="text-lg font-semibold text-black">{{ 'STATUS_ACTIVE' | translate }}</p>
                        <p class="text-base text-black">
                            {{ ticket.startDate | formatTimeZone: dateTimeFormat : timezone }}<br />
                            {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                        </p>
                    </div>
                    <div
                        class="flex h-8 w-fit items-center justify-center rounded-full bg-grey-zambezy px-4 dark:bg-contrast-yellow">
                        <p class="orb-app-light:text-white text-sm font-bold text-white">
                            {{ 'TICKET_NOT_CURRENTLY_VALID' | translate }}
                        </p>
                    </div>
                </div>
                <div
                    class="flex flex-col items-center gap-6"
                    *ngIf="
                        (ticket.status === FareContractStatus.CONFIRMED &&
                            ticket.timestamps?.firstActivationWithinEnd) ||
                        isMenuReactivationEnabled(ticket)
                    ">
                    <p>
                        <b>
                            {{
                                ticket.status === FareContractStatus.CONFIRMED &&
                                ticket.timestamps?.firstActivationWithinEnd
                                    ? ('INACTIVE_TICKET_ACTIVATION_TIME' | translate)
                                    : ('ACTIVATE_UNTIL' | translate)
                            }}
                        </b>
                        <br />
                        {{
                            ticket.status === FareContractStatus.CONFIRMED &&
                            ticket.timestamps?.firstActivationWithinEnd
                                ? (ticket.timestamps?.firstActivationWithinEnd
                                  | formatTimeZone: dateTimeFormat : timezone)
                                : (ticket.timestamps?.activationWindowEnd | formatTimeZone: dateTimeFormat : timezone)
                        }}
                    </p>

                    <div
                        class="flex h-8 w-fit items-center justify-center rounded-full bg-secondary px-4 dark:bg-contrast-yellow"
                        *ngIf="ticket.allowedActions?.activationsLeft && isMultiTrip(ticket)">
                        <p class="orb-app-light:text-white text-sm font-bold uppercase text-black">
                            {{ ticket.allowedActions?.activationsLeft }} {{ 'BOOKLET_ACTIVATIONS_LEFT' | translate }}
                        </p>
                    </div>
                </div>

                <div
                    class="flex flex-col items-center gap-6"
                    *ngIf="
                        ticket.status === FareContractStatus.CONFIRMED &&
                        !(ticket.timestamps?.firstActivationWithinEnd || isMenuReactivationEnabled(ticket))
                    ">
                    <p class="text-sm font-bold uppercase text-black">
                        {{ 'RIDE_STATUS_CONFIRMED' | translate }}
                    </p>
                    <div
                        class="flex h-8 w-fit items-center justify-center rounded-full bg-secondary px-4 dark:bg-contrast-yellow"
                        *ngIf="ticket.allowedActions?.activationsLeft && isMultiTrip(ticket)">
                        <p class="orb-app-light:text-white text-sm font-bold uppercase text-black">
                            {{ ticket.allowedActions?.activationsLeft }} {{ 'BOOKLET_ACTIVATIONS_LEFT' | translate }}
                        </p>
                    </div>
                </div>

                <p
                    class="orb-app-light:text-red text-sm font-semibold uppercase text-black"
                    *ngIf="ticket.status === FareContractStatus.CONSUMED">
                    {{ 'TICKET_USED' | translate }}
                </p>

                <p
                    class="text-red text-sm font-semibold uppercase dark:text-contrast-black"
                    *ngIf="ticket.status === FareContractStatus.CANCELLED">
                    {{ 'RIDE_STATUS_CANCELLED' | translate }}
                    <span *ngIf="env.SHOW_HISTORY_TICKET_CANCELED_DATES">
                        <br />{{ ticket.timestamps?.cancellationTimestamp | formatTimeZone: dateTimeFormat : timezone }}
                    </span>
                </p>

                <p
                    class="text-red text-sm font-semibold uppercase dark:text-contrast-black"
                    *ngIf="ticket.status === FareContractStatus.EXPIRED">
                    {{ 'TICKET_EXPIRED' | translate }}
                    <span class="text-base font-normal" *ngIf="env.TICKET?.SHOW_HISTORY_TICKET_EXPIRED_DATES">
                        <br />{{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                    </span>
                </p>

                <p
                    class="text-sm font-semibold uppercase text-black"
                    *ngIf="ticket.status === FareContractStatus.REFUNDED">
                    {{ 'TICKET_REFUNDED' | translate }}
                    <span *ngIf="env.SHOW_HISTORY_TICKET_REFUND_DATES">
                        <br />{{ ticket.timestamps?.refundTimestamp | formatTimeZone: dateTimeFormat : timezone }}
                    </span>
                </p>

                <p
                    class="text-sm font-semibold uppercase text-black"
                    *ngIf="ticket.status === FareContractStatus.PENDING && env.SHOW_HISTORY_TICKET_REFUND_DATE">
                    {{ 'TICKET_PENDING' | translate }}
                    <span>
                        <br />{{ ticket.timestamps?.refundTimestamp | formatTimeZone: dateTimeFormat : timezone }}
                    </span>
                </p>
            </div>

            <p class="text-xs font-medium text-grey-dark" *ngIf="env.ZOOMABLE_QR_CODE">
                {{ 'TAP_TO_ZOOM' | translate }}
            </p>
        </section>
        <div
            class="mb-4 box-border flex w-full items-center justify-center rounded-lg bg-grey-zambezy p-2 text-white"
            *ngIf="ticket.lendingDetails?.lent || ticket.lendingDetails?.borrowed">
            <div
                class="flex flex-col px-4 pb-4 pt-5 text-center text-base font-normal leading-tight dark:text-contrast-yellow">
                <span>
                    {{ (ticket.lendingDetails?.lent ? 'LEND_TICKET_DESCRIPTION' : 'BORROWED') | translate }}
                </span>
                <span>
                    {{
                        ticket.lendingDetails?.lent
                            ? ticket.lendingDetails?.lentFareContracts?.[0]?.email
                            : ticket.lendingDetails?.borrowedFareContract?.email
                    }}
                </span>
            </div>
        </div>

        <h2 class="my-2.5 text-base font-bold" #ticketTitleEl tabindex="0">{{ ticketTitle$ | async }} <br /></h2>

        <div
            *ngIf="
                ticket.allowedActions.activationsLeft &&
                isMultiTrip(ticket) &&
                env.SHOW_ACTIVATIONS_LEFT_IN_TITLE &&
                !accordionValue
            ">
            <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                {{ 'BOOKLET_ACTIVATIONS_LEFT' | translate }}
            </h3>
            <p class="text-base">{{ ticket.allowedActions.activationsLeft }}</p>
        </div>

        <section
            class="mb-4 flex flex-col gap-3"
            *ngIf="ticket.owner?.accountType === 'SCHOOL'"
            [ngClass]="{
                'border-b border-solid border-black/10 pb-4 dark:border-contrast-yellow': accordionValue
            }">
            <div>
                <h3 class="text-grey-darky text-xs font-medium dark:text-contrast-yellow">
                    {{ 'CHOOSE_TRAVELLER_PROFILE' | translate }}
                </h3>
                <p class="text-base">{{ ticket.owner.firstName }} {{ ticket.owner.lastName }}</p>
            </div>
            <div>
                <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                    {{ 'DOB' | translate }}
                </h3>
                <p class="text-base">{{ ticket.owner.dateOfBirth }}</p>
            </div>
            <div>
                <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                    {{ 'SCHOOL' | translate }}
                </h3>
                <p class="text-base">{{ ticket.owner?.school.name }}</p>
            </div>
        </section>

        <ng-container *ngIf="showDetails">
            <ion-accordion-group [(value)]="accordionValue">
                <ion-accordion class="accordion-external-control" value="detailsShown">
                    <div class="ion-padding" slot="content">
                        <section
                            class="mb-4 flex flex-col gap-3 border-b border-solid border-black/10 pb-4 dark:border-contrast-yellow">
                            <div>
                                <h3 class="pb-1 text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                    {{ 'PRODUCT_TYPE' | translate }}
                                </h3>
                                <p class="text-base text-black">
                                    {{
                                        ticket.typeOfProduct?.name | translateObjectField: 'translations' : currentLang
                                    }}
                                </p>
                            </div>
                            <div *ngIf="ticket.userProfiles?.[0]">
                                <h3 class="pb-1 text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                    {{ 'USER_PROFILE' | translate }}
                                </h3>
                                <p class="text-base text-black">
                                    {{
                                        ticket.typeOfProduct?.code === 'SINGLE_TICKET_GROUP'
                                            ? travellers
                                            : (ticket.userProfiles[0]?.nameTranslations
                                              | translateObjectField: 'translations' : currentLang)
                                    }}
                                </p>
                            </div>

                            <div *ngIf="ticket.geography?.zones?.[0]">
                                <div class="flex items-center justify-between">
                                    <h3 class="pb-1 text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'GEOGRAPHY' | translate }}
                                    </h3>
                                    <ion-button
                                        class="my-0 h-auto text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
                                        *ngIf="
                                            (isOnline$ | async) === true &&
                                            productAreaDisplayOption === PRODUCT_AREA_DISPLAY_OPTION.SPLIT_AREA &&
                                            hasZoneMapImage
                                        "
                                        (click)="openZoneMapFromGeography()"
                                        fill="clear">
                                        {{ 'TICKET_SUMMARY_SHOW_ZONE_ON_MAP' | translate }}
                                        <mat-icon class="ml-1 text-sm">arrow_forward</mat-icon>
                                    </ion-button>
                                </div>
                                <p class="text-base text-black">
                                    {{
                                        ticket.geography.zones[0]?.name
                                            | translateObjectField: 'translations' : currentLang
                                    }}
                                    <ng-container *ngIf="ticket.geography.zones.length > 1">
                                        –
                                        {{
                                            ticket.geography.zones[ticket.geography.zones.length - 1]?.name
                                                | translateObjectField: 'translations' : currentLang
                                        }}
                                    </ng-container>
                                </p>
                            </div>
                            <div *ngIf="ticket.timeIntervals?.[0]">
                                <h3 class="pb-1 text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                    {{ 'PRODUCT_VALIDITY' | translate }}
                                </h3>
                                <p class="text-base text-black">
                                    {{
                                        ticket.timeIntervals[0]?.name
                                            | translateObjectField: 'translations' : currentLang
                                    }}
                                </p>
                            </div>
                            <div *ngIf="ticket.startDate && ticket.endDate">
                                <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                    {{ 'ACTIVE_PERIOD' | translate }}
                                </h3>
                                <p class="text-base text-black">
                                    {{ ticket.startDate | formatTimeZone: dateTimeFormat : timezone }}<br />
                                    {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                                </p>
                            </div>
                        </section>

                        <section
                            class="mb-4 flex flex-col gap-3 border-b border-solid border-black/10 pb-4 dark:border-contrast-yellow"
                            *ngIf="isMultiTrip(ticket)">
                            <div *ngIf="ticket?.allowedActions?.activationsLeft">
                                <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                    {{ 'BOOKLET_ACTIVATIONS_LEFT' | translate }}
                                </h3>
                                <p class="text-base text-black">
                                    {{ ticket.allowedActions.activationsLeft }} ({{
                                        'BOOKLET_OUT_OF_ACTIVATIONS' | translate
                                    }}
                                    {{ ticket?.activations?.[0]?.maxNumberOfActivations }})
                                </p>
                            </div>
                            <div
                                *ngIf="
                                    ticket.timestamps?.activationWindowStart && ticket.timestamps?.activationWindowEnd
                                ">
                                <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                    {{ 'BOOKLET_ACTIVATION_WINDOW' | translate }}
                                </h3>
                                <p class="text-base text-black">
                                    {{
                                        ticket.timestamps.activationWindowStart
                                            | formatTimeZone: dateTimeFormat : timezone
                                    }}<br />
                                    {{
                                        ticket.timestamps.activationWindowEnd
                                            | formatTimeZone: dateTimeFormat : timezone
                                    }}
                                </p>
                            </div>
                        </section>

                        <section
                            class="mb-4 flex flex-col gap-3 border-b border-solid border-black/10 pb-4 dark:border-contrast-yellow"
                            *ngIf="ticket.price">
                            <div class="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-2">
                                <div *ngIf="ticket.price">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'PRICE_PAID' | translate }}
                                    </h3>
                                    <p class="text-base text-black">
                                        {{ ticket.price | moneyFormat }} {{ ticket.price.currency | translate }}
                                    </p>
                                </div>
                                <div *ngIf="ticket.distributionAssignment?.paymentMethods?.length">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'CART_PAYMENT_METHOD' | translate }}
                                    </h3>
                                    <p class="text-base text-black">{{ usedPaymentMethodsList }}</p>
                                </div>
                                <div *ngIf="ticket.purchaseAt">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'PURCHASED_ON' | translate }}
                                    </h3>
                                    <p class="text-base text-black">
                                        {{ ticket.purchaseAt | formatTimeZone: dateTimeFormat : timezone }}
                                    </p>
                                </div>
                                <div
                                    *ngIf="
                                        ticket.status === FareContractStatus.CANCELLED &&
                                        ticket.timestamps?.cancellationTimestamp
                                    ">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'CANCELLED_ON' | translate }}
                                    </h3>
                                    <p class="text-base text-black">
                                        {{
                                            ticket.timestamps?.cancellationTimestamp
                                                | formatTimeZone: dateTimeFormat : timezone
                                        }}
                                    </p>
                                </div>
                                <div
                                    *ngIf="
                                        ticket.status === FareContractStatus.REFUNDED &&
                                        ticket.timestamps?.refundTimestamp
                                    ">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'REFUNDED_ON' | translate }}
                                    </h3>
                                    <p class="text-base text-black">
                                        {{
                                            ticket.timestamps?.refundTimestamp
                                                | formatTimeZone: dateTimeFormat : timezone
                                        }}
                                    </p>
                                </div>
                            </div>
                        </section>
                        <section class="mb-4 flex flex-col gap-3">
                            <div class="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-2">
                                <div *ngIf="ticket.id">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'CART_TICKET_NUMBER' | translate }}
                                    </h3>
                                    <p class="text-base text-black">{{ ticket.id }}</p>
                                </div>
                            </div>
                            <div class="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-2">
                                <div *ngIf="ticket.distributionAssignment?.organisation?.name">
                                    <h3 class="text-xs font-medium text-grey-dark dark:text-contrast-yellow">
                                        {{ 'TICKET_ISSUER' | translate }}
                                    </h3>
                                    <p class="text-base text-black">
                                        {{
                                            ticket.distributionAssignment?.organisation?.name
                                                | translateObjectField: 'translations' : currentLang
                                        }}
                                    </p>
                                </div>
                            </div>
                        </section>
                    </div>
                </ion-accordion>
            </ion-accordion-group>
        </ng-container>

        <button
            class="orb-app-light-dark:text-secondary inline-flex w-full items-center py-4 text-left font-semibold dark:text-contrast-yellow"
            (click)="toggleExpandCollapseDetailedInfo()">
            <ion-icon
                class="align-middle text-base dark:filter-yellow"
                *ngIf="this.env.TICKET.SHOW_TICKET_DETAILS_MORE_INFO_TOGGLE_ICON"
                [src]="
                    (assetsPath$ | async) +
                    '/img/ticket-details/icon-arrow-' +
                    (showDetails ? 'up' : 'down') +
                    '-circle.svg'
                "
                aria-hidden="true"></ion-icon>
            <span class="orb-app-light-dark:text-xm align-middle">{{
                (showDetails ? 'CART_TICKET_HIDE_DETAILS' : 'TICKET_SHOW_DETAILS') | translate
            }}</span>
        </button>
    </div>

    <hr class="my-4 w-full border-0 border-t border-solid border-black/10 dark:border-contrast-yellow" />

    <div class="var-app-light-dark:flex var-app-light-dark:flex-col pb-4" *ngIf="isOnline$ | async">
        <ng-container *ngFor="let action of ticketBtns">
            <button
                class="w-full text-center text-base font-semibold leading-5 text-primary shadow-none dark:bg-contrast-yellow dark:text-contrast-black"
                [class]="action.cssClass"
                [disabled]="action.disabled"
                (click)="action.handler()">
                {{ action.text }}
            </button>
        </ng-container>
    </div>
</div>
<rwidget-no-internet-alert></rwidget-no-internet-alert>
